import { api } from '@/api/core';
import { DEPARTMENTS_LIST_TAG } from '@/api/constants';

export type DepartmentListItem = {
  departmentId: string;
  name: string;
};

export type DepartmentsListResponse = {
  departments: DepartmentListItem[];
};

const departmentsListApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDepartmentsList: builder.query<DepartmentsListResponse, void>({
      query: () => ({
        url: `departments/list`,
        method: 'GET',
      }),
      providesTags: () => [{ type: DEPARTMENTS_LIST_TAG }],
    }),
  }),
});

export const { useGetDepartmentsListQuery } = departmentsListApi;
